import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ALertOption } from 'src/app/Models/alert/alert-option';
import { AlertType } from 'src/app/Models/alert/alert-type';
import { Articulo } from 'src/app/Models/articulo/articulo';
import { Compra } from 'src/app/Models/compra/compra/compra';
import { DetalleCompra } from 'src/app/Models/compra/detallecompra/detalle-compra';
import { Guia } from 'src/app/Models/guia/guia';
import { Moneda } from 'src/app/Models/moneda/moneda';
import { Precio } from 'src/app/Models/precio/precio';
import { Proveedor } from 'src/app/Models/proveedor/proveedor';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { ArticuloDialogComponent } from '../../articulo/articulo-dialog/articulo-dialog.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { ComprasArticuloComponent } from '../compras-detcompra/compras-detcompra.component';
import { ComprasProveedorComponent } from '../compras-proveedor/compras-proveedor.component';
import { SearchFacturaComponent } from '../search-factura/search-factura.component';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { Numero } from 'src/app/Models/numero/numero';
import * as moment from 'moment';
import { TipoDocumento } from 'src/app/Models/tipodocumento/tipo-documento';
import { AddProveedorComponent } from '../../proveedor/add-proveedor/add-proveedor.component';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-add-compra',
  templateUrl: './add-compra.component.html',
  styleUrls: ['./add-compra.component.css']
})
export class AddCompraComponent implements OnInit {

  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild('inptprove', null) inptprove: ElementRef;
  @ViewChild('listadetcompras', null) listadetcompras: ElementRef;
  @ViewChild('icon', null) icon: ElementRef;
  @ViewChild(ComprasProveedorComponent, null) public fmrcomprasproveedor: ComprasProveedorComponent;
  @ViewChild(ComprasArticuloComponent, null) public frmcomprasdetalles: ComprasArticuloComponent;
  @ViewChild(ArticuloDialogComponent, null) public fmarticulodialog: ArticuloDialogComponent;
  @ViewChild(SearchFacturaComponent, null) public frmsearchfactura: SearchFacturaComponent;
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  @ViewChild('txtdireccion', null) txtdireccion: ElementRef;
  @ViewChild('frmcompra', null) btnshownewcompra: ElementRef;
  expandedStates: boolean[] = [false];
  public usuario: Usuario = new Usuario();
  public compra: Compra = new Compra();
  public articulo: Articulo = new Articulo();
  public precio: Precio = new Precio();
  public proveedor: Proveedor = new Proveedor();
  public detcompras: DetalleCompra[] = [];
  public monedas: Moneda[] = [];
  public tipodocs: any[] = [];
  public guias: Guia[] = [];
  public testitem: DetalleCompra = new DetalleCompra();
  public detcompra: DetalleCompra = new DetalleCompra();
  public funcion: Function;
  public isShow: boolean = false;

  submitted = false;
  public serie_boleta: Numero = new Numero();
  public serie_factura: Numero = new Numero();
  public alertType: AlertType = new AlertType();
  public options: ALertOption = new ALertOption();
  public isadddetcompra: boolean = false;
  public isnota: boolean = false
  public index: number = 0;
  public numitem: number = 1;
  public pagarticulo: any;
  public fechaHoraActual: Date;
  public tipodocumentos: TipoDocumento[] = [];
  public isedit: boolean = false;
  private recalculando = false;
  // Lista de proveedores para el select
  public proveedores: Proveedor[] = [];

  constructor(private title: Title, private data: DataService, private notify: NotifyService, private auth: AuthService, private route: Router, private dialog: MatDialog) {
    this.getMonedas();
    this.getTipodoc();
    this.fechaHoraActual = new Date();
    this.usuario = this.auth.getCurrentUser();


  }

  ngOnInit() {
    this.title.setTitle('Compras | Sistema de ventas');
    this.usuario = this.auth.getCurrentUser();
    this.compra.moneda = "S/"

  }

  public show(affterfunction: Function = null, fupdate: Function = null) {

    this.funcion = affterfunction;
    this.isShow = true;
    this.isedit == true ? null : this.proveedor.ruc = '';
    this.compra.moneda = 'PEN';
    this.compra.idsucursal = this.data.getSucursalId()
    this.compra.estado = 'EMI';
    this.compra.documento = 'BOL';
    this.compra.tipo_ope = '01';
    this.compra.tipo_ope = '1';
    this.compra.tcambio = 1;
    this.compra.igv = 18;
    this.compra.fecemi = moment(this.fechaHoraActual).format('YYYY-MM-DD');
    setTimeout(async () => {
      this.btnshownewcompra.nativeElement.click();
      this.loading.show('Cargando datos');
      this.getProveedores();
      this.getTipoDocumento();
      if (this.isedit) {
        this.getDetCompras()
      }
      this.loading.hide();
      console.log("mostrando series");
      console.log(this.serie_boleta);
      console.log(this.serie_factura);
    }, 10);
  }

  getTipoDocumento() {

    this.data.GetSimple(this.data.api.tipodocumento).subscribe(r => {
      try {
        this.tipodocumentos = r;
      } catch (ex) { console.log(ex); }
    });
  }

  getTipocambio() {
    this.data.GetTipoCambio(this.compra.fecemi).then(r => {
      console.log(r);
      this.compra.tcambio = r.venta;

    })
  }

  async GetCliente() {
    console.log("buscando cliente");
    await this.data.AsyncGetFromValue(this.data.api.proveedor, 'ruc', this.proveedor.ruc).then(async r => {
      console.log(r);

      if (r.length < 1) {
        console.log("buscando en sunat");
        await this.data.Consulta('ruc', this.proveedor.ruc).then(r => {
          console.log(r);
          if (r.result != 0 && r.message.razon_social != null) {
            this.proveedor.razonsocial = r.message.razon_social
            this.proveedor.direccion = r.message.domicilio_fiscal

          } else {
            console.log(r.message);
            this.proveedor.idprovee ? this.proveedor = new Proveedor() : null
            this.data.notify("Usuario no encontrado", "Error", this.alertType.warning, this.options, this.inptprove.nativeElement.focus());

          }
        }).catch(e => { this.data.notify("Usuario no encontrado", "Error", this.alertType.warning, this.options, this.inptprove.nativeElement.focus()) });
      } else {
        console.log(r);
        this.proveedor = r[0];
        this.compra.idprovee = this.proveedor.idprovee

      }
    }, e => {
      this.data.notify("Usuario no encontrado", "Error", this.alertType.error); console.log(e);
    })
  }

  getMonedas() {
    this.data.GetSimple(this.data.api.moneda).subscribe(r => {
      console.log(r);
      this.monedas = r;
    })
  }


  getTipodoc() {
    this.data.GetSimple(this.data.api.tipodocumento).subscribe(r => {
      console.log(r);
      this.tipodocs = r;
    })
  }

  async guardarProveedor() {
    console.log(this.proveedor);
    if (this.proveedor.idprovee == undefined) {
      await this.data.AsyncPost(this.data.api.proveedor, this.proveedor).then(r => {
        if (r.length < 1) {
          console.log(r);

        } else {
          this.compra.idprovee = r.idprovee;
          this.proveedor.idprovee = r.idprovee;
          console.log(this.compra);

        }
      }).catch(e => { console.log(e); this.data.notify("Ingrese un usuario", "Error", this.alertType.error); });
    } else {
      console.log("Proveedor ya existente");

    }
  }

  async actualizarProveedor() {
    console.log(this.proveedor);
    await this.data.AsyncPut(this.data.api.proveedor, this.proveedor.idprovee, this.proveedor).then(r => {

    }).catch(e => { console.log(e); this.data.notify("Ingrese un proveedor", "Error", this.alertType.error); });
  }

  validisnota() {
    if (this.compra.documento === 'NCR')
      this.isnota = true;
    else
      this.isnota = false
  }

  DeleteDetCompra(index: number) {
    this.detcompras.splice(index, 1);
    this.actualizarTotalesCompra()
  }

  close() {
    this.detcompras = [];
    this.btnclose.nativeElement.click();
    setTimeout(() => { this.isShow = false; }, 1000);
    setTimeout(() => { if (this.funcion != null) { this.funcion(); } }, 10);
  }


  // async GuardarCompra(){
  //   console.log(this.compra);
  //   await this.guardarProveedor().then(async () =>{
  //     this.compra.proveedor = this.proveedor;
  //     await this.data.AsyncPost(this.data.api.compra,this.compra).then(r=>{
  //       if (r.idcompra !=null) {
  //         console.log("cabezera guardada");
  //         console.log(this.detcompras);
  //         console.log(r);
  //         this.detcompras.forEach(compra => {
  //           console.log(compra.idproduct);
  //           compra.idcompra = r.idcompra
  //           this.data.AsyncPost(this.data.api.detcompra,compra).then(d=>{
  //             this.data.notify("Elemento guardado","Exito",this.alertType.success,this.options,this.refresh());
  //             console.log(d);
  //             if (d.length>0) {
  //               console.log("detalle guardado");
  //               console.log(d);
  //             }
  //           });
  //         });
  //       }else{
  //         console.log("error");
  //         console.log(r);
  //       }
  //     })
  //   }).catch(()=>this.data.notify("Error al guardar compra","Error",this.alertType.error)).finally(()=>this.close())

  // }

  async GuardarCompra() {
    console.log(this.compra);

    try {
      this.loading.show("Guardando Datos");
      await this.guardarProveedor();
      this.compra.proveedor = this.proveedor;

      const r = await this.data.AsyncPost(this.data.api.compra, this.compra);

      if (r.idcompra != null) {
        console.log("cabezera guardada");
        console.log(this.detcompras);
        console.log(r);

        const detallePromises = this.detcompras.map(async (compra) => {
          console.log(compra.idproduct);
          compra.idcompra = r.idcompra;

          const d = await this.data.AsyncPost(this.data.api.detcompra, compra);

          this.data.notify("Elemento guardado", "Exito", this.alertType.success, this.options, this.refresh());
          console.log(d);

          if (d.length > 0) {
            console.log("detalle guardado");
            console.log(d);
          }
        });

        await Promise.all(detallePromises);
        this.data.notify("Datos guardados exitosamente", "Exito", this.alertType.success, new ALertOption, () => {
          this.loading.hide();
          this.close()
        });
        // Solo cerramos el modal si todo fue exitoso
      } else {
        console.log("error");
        console.log(r);
        this.loading.hide();
        this.data.notify("Error al guardar compra", "Error", this.alertType.error);
      }
    } catch (error) {
      console.error("Error al guardar compra", error);
      this.onSubmit()
      this.loading.hide();
      this.data.notify("Error al guardar compra, faltan campos.", "Error", this.alertType.error);
    }
  }

  async ActualizarCompra() {
    await this.actualizarProveedor().then(async () => {
      this.compra.proveedor = this.proveedor;
      this.compra.idprovee = this.proveedor.idprovee
      await this.data.AsyncPut(this.data.api.compra, this.compra.idcompra, this.compra).then(r => {
        if (r.status === 'success') {
          console.log("cabezera guardada");
          console.log(this.detcompras);
          console.log(r);
          this.detcompras.forEach(compra => {
            compra.idcompra = compra.idcompra.idcompra
            compra.idproduct = compra.idproduct.idproduct
            this.data.AsyncPut(this.data.api.detcompra, compra.id_det, compra).then(d => {
              this.data.notify("Elemento guardado", "Exito", this.alertType.success, this.options, this.refresh());
              console.log(d);
              if (d.length > 0) {
                console.log("detalle guardado");
                console.log(d);
              }
            });
          });
        } else {
          console.log("error");
          console.log(r);
        }
      })
    }).catch(() => this.data.notify("Error al guardar compra", "Error", this.alertType.error)).finally(() => this.close())
  }

  AddGuia() {
    let newguia: Guia = new Guia();

    newguia.guia_serie = '';
    newguia.guia_numero = '';
    this.guias.push(newguia);
  }

  DeleteGuia() { this.guias.pop(); }

  UpdateGuia(index: number, field: string, value: string) {
    this.guias[index][field] = value;
  }

  private redondear(valor: number, decimales: number = 2): number {
    const factor = Math.pow(10, decimales);
    // Usamos una técnica más precisa para evitar errores de punto flotante
    return Math.round((valor + Number.EPSILON) * factor) / factor;
  }

  // Cálculos para cada item
  calcularValVenta(item: DetalleCompra): void {
    if (item.cantidad !== undefined && item.precio !== undefined) {
      // Calculamos con máxima precisión y solo redondeamos al final
      const calculo = item.cantidad * item.precio;
      item.subtotal1 = this.redondear(calculo);
    }
  }

  calcularIgv(item: DetalleCompra): void {
    if (item.subtotal1 !== undefined && item.igv !== undefined) {
      const calculo = item.subtotal1 * (item.igv / 100);
      item.igv_unit = this.redondear(calculo);
    }
  }

  calcularPrecioUnit(item: DetalleCompra): void {
    if (item.precio !== undefined && item.igv !== undefined) {
      const calculo = item.precio * (1 + item.igv / 100);
      item.precioreal = this.redondear(calculo);
    }
  }

  calcularTotalItem(item: DetalleCompra): void {
    if (item.subtotal1 !== undefined && item.igv !== undefined) {
      // Calculamos el total con IGV
      const calculo = item.subtotal1 * (1 + item.igv / 100);
      item.subtotal2 = this.redondear(calculo);

      // Para evitar problemas de redondeo, verificamos si hay una discrepancia
      // y usamos el cálculo directo desde precioreal si es necesario
      if (item.precioreal !== undefined && item.cantidad !== undefined) {
        const calculoDirecto = item.cantidad * item.precioreal;
        if (Math.abs(calculoDirecto - item.subtotal2) > 0.01) {
          item.subtotal2 = this.redondear(calculoDirecto);
        }
      }
    }
  }

  calcularValorUnit(item: DetalleCompra): void {
    if (item.precioreal !== undefined && item.igv !== undefined) {
      const calculo = item.precioreal / (1 + (item.igv / 100));
      item.precio = this.redondear(calculo);
    }
  }

  // Cálculos para los totales
  calcularMontoTotal(): void {
    this.compra.total = 0;
    if (this.detcompras.length > 0) {
      this.compra.total = this.detcompras.reduce((total, detalle) => {
        return total + (detalle.subtotal2 || 0);
      }, 0);
      this.compra.total = this.redondear(this.compra.total);
    }
  }

  calcularValorCompra(): void {
    this.compra.valorcom = 0;
    if (this.detcompras.length > 0) {
      this.compra.valorcom = this.detcompras.reduce((total, detalle) => {
        return total + (detalle.subtotal1 || 0);
      }, 0);
      this.compra.valorcom = this.redondear(this.compra.valorcom);
    }
  }

  calcularTotalIGV(): void {
    this.compra.igv = 0;
    if (this.detcompras.length > 0) {
      this.compra.igv = this.detcompras.reduce((total, detalle) => {
        return total + (detalle.igv_unit || 0);
      }, 0);
      this.compra.igv = this.redondear(this.compra.igv);
    }
  }

  calcularPercepcion(): void {
    if (this.compra.total !== undefined && this.compra.tasapercepcion !== undefined) {
      const calculo = this.compra.total * (this.compra.tasapercepcion / 100);
      this.compra.percepcion = this.redondear(calculo);
    }
  }

  calcularTotalCompra(): void {
    if (this.compra.total !== undefined && this.compra.percepcion !== undefined) {
      const calculo = this.compra.total + this.compra.percepcion;
      this.compra.totalper = this.redondear(calculo);
    }
  }

  // Métodos de flujo principal
  calcularDesdePrecio(index: number): void {
    const item = this.detcompras[index];
    this.calcularValVenta(item);
    this.calcularIgv(item);
    this.calcularPrecioUnit(item);
    this.calcularTotalItem(item);
    this.actualizarTotalesCompra();
  }

  calcularDesdePrecioReal(index: number): void {
    const item = this.detcompras[index];
    this.calcularValorUnit(item);
    this.calcularValVenta(item);
    this.calcularIgv(item);
    this.calcularTotalItem(item);
    this.actualizarTotalesCompra();
  }

  actualizarTotalesCompra(): void {
    this.calcularMontoTotal();
    this.calcularValorCompra();
    this.calcularTotalIGV();
    this.calcularPercepcion();
    this.calcularTotalCompra();
  }

  // Manejo de eventos desde la tabla
  // UpdateDetCompra(index: number, field: string, value: string): void {
  //   const numericValue = parseFloat(value) || 0;
  //   this.detcompras[index][field] = numericValue;

  //   if (field === 'cantidad' || field === 'precio') {
  //     this.calcularDesdePrecio(index);
  //   } else if (field === 'igv') {
  //     this.calcularDesdePrecio(index);
  //   } else if (field === 'precioreal') {
  //     this.calcularDesdePrecioReal(index);
  //   }
  // }

  UpdateDetCompra(index: number, field: string, value: string): void {
    if (this.recalculando) return;

    this.recalculando = true;

    try {
      const item = this.detcompras[index];
      const numValue = parseFloat(value) || 0;
      item[field] = numValue;

      // Determinar flujo de cálculo según el campo modificado
      switch (field) {
        case 'cantidad':
          // Solo recalcular subtotales, NO los precios unitarios
          this.recalcularSubtotales(item);
          break;

        case 'precio':
        case 'igv':
          // Recalcular todo desde precio sin IGV
          this.recalcularDesdePrecioSinIGV(item);
          break;

        case 'precioreal':
          // Recalcular todo desde precio con IGV
          this.recalcularDesdePrecioConIGV(item);
          break;
      }

      this.recalcularTotales();
    } finally {
      this.recalculando = false;
    }
  }

  // NUEVO: Solo recalcular subtotales (cuando cambia cantidad)
  private recalcularSubtotales(item: DetalleCompra): void {
    const cantidad = item.cantidad || 0;
    const precio = item.precio || 0;
    const igv = item.igv || 0;

    // subtotal1 = cantidad × precio
    item.subtotal1 = parseFloat((cantidad * precio).toFixed(3));

    // igv_unit = subtotal1 × (igv% / 100)
    item.igv_unit = parseFloat((item.subtotal1 * (igv / 100)).toFixed(3));

    // subtotal2 = subtotal1 + igv_unit
    item.subtotal2 = parseFloat((item.subtotal1 + item.igv_unit).toFixed(2));

    // NO recalcular precioreal ni precio aquí
  }

  // Flujo: precio sin IGV → precio con IGV
  private recalcularDesdePrecioSinIGV(item: DetalleCompra): void {
    const cantidad = item.cantidad || 0;
    const precio = item.precio || 0;
    const igv = item.igv || 0;

    // subtotal1 = cantidad × precio
    item.subtotal1 = parseFloat((cantidad * precio).toFixed(3));

    // igv_unit = subtotal1 × (igv% / 100)
    item.igv_unit = parseFloat((item.subtotal1 * (igv / 100)).toFixed(3));

    // precioreal = precio × (1 + igv% / 100)
    item.precioreal = parseFloat((precio * (1 + igv / 100)).toFixed(2));

    // subtotal2 = subtotal1 + igv_unit
    item.subtotal2 = parseFloat((item.subtotal1 + item.igv_unit).toFixed(2));
  }

  // Flujo: precio con IGV → precio sin IGV
  private recalcularDesdePrecioConIGV(item: DetalleCompra): void {
    const cantidad = item.cantidad || 0;
    const precioreal = item.precioreal || 0;
    const igv = item.igv || 0;

    // precio = precioreal / (1 + igv% / 100)
    item.precio = parseFloat((precioreal / (1 + igv / 100)).toFixed(6));

    // subtotal1 = cantidad × precio
    item.subtotal1 = parseFloat((cantidad * item.precio).toFixed(3));

    // igv_unit = subtotal1 × (igv% / 100)
    item.igv_unit = parseFloat((item.subtotal1 * (igv / 100)).toFixed(3));

    // subtotal2 = subtotal1 + igv_unit
    item.subtotal2 = parseFloat((item.subtotal1 + item.igv_unit).toFixed(2));
  }

  // Recalcular todos los totales de la compra
  recalcularTotales(): void {
    const valorcom = this.detcompras.reduce((sum, d) => sum + (d.subtotal1 || 0), 0);
    this.compra.valorcom = parseFloat(valorcom.toFixed(2));

    const igv = this.detcompras.reduce((sum, d) => sum + (d.igv_unit || 0), 0);
    this.compra.igv = parseFloat(igv.toFixed(2));

    const total = this.detcompras.reduce((sum, d) => sum + (d.subtotal2 || 0), 0);
    this.compra.total = parseFloat(total.toFixed(2));

    if (this.compra.tasapercepcion && this.compra.tasapercepcion > 0) {
      this.compra.percepcion = parseFloat(
        (this.compra.total * (this.compra.tasapercepcion / 100)).toFixed(2)
      );
    } else {
      this.compra.percepcion = 0;
    }

    this.compra.totalper = parseFloat(
      (this.compra.total + this.compra.percepcion).toFixed(2)
    );
  }

  ShowNewDetcompra() {
    this.frmcomprasdetalles.articulo = null;
    this.frmcomprasdetalles.show(() => {
      document.getElementById('frmcompra').style.overflow = 'auto';
      let newdetalle: DetalleCompra = new DetalleCompra();
      console.log("Detalle obtenido", newdetalle);

      if (this.frmcomprasdetalles.articulo != null) {
        newdetalle.item = this.detcompras.length + 1;
        newdetalle.articulo = this.frmcomprasdetalles.articulo;
        newdetalle.idproduct = this.frmcomprasdetalles.articulo.idproduct;
        newdetalle.afectoigv = (+this.frmcomprasdetalles.articulo.afectoigv);

        const igvPorcentaje = newdetalle.afectoigv ? 18 : 0;

        // INICIALIZAR VALORES
        newdetalle.cantidad = 1;
        newdetalle.igv = igvPorcentaje;
        newdetalle.precioreal = this.frmcomprasdetalles.articulo.ultcosto; // Precio con IGV
        newdetalle.precio = parseFloat(
          (newdetalle.precioreal / (1 + igvPorcentaje / 100)).toFixed(6)
        ); // Precio sin IGV

        // Solo calcular subtotales, NO recalcular precios
        this.recalcularSubtotales(newdetalle);

        this.detcompras.push(newdetalle);
        this.recalcularTotales();
      }
    });
  }


  // UpdateDetCompra(index: number, field: string, value: string) {
  //   this.detcompras[index][field] = value;
  //   if (field === 'cantidad' || field === 'igv' || field === 'precio') {
  //     this.Calcular(index);
  //   }else if(field === 'precio' || field === 'precioreal' ){
  //     this.CalcularUnit(index);
  //   }

  // }


  toggleAccordion(index: number): void {
    this.expandedStates[index] = !this.expandedStates[index];
    this.toggleIcon(index);
  }

  toggleIcon(index: number): void {
    const icon = this.icon.nativeElement;
    if (this.expandedStates[index]) {
      icon.classList.add('rotate-180');
    } else {
      icon.classList.remove('rotate-180');
    }
  }

  refresh(): Function {
    this.compra = new Compra();
    this.detcompras = [];
    return null
  }

  ShowSearchFactura() {
    this.frmsearchfactura.factura = null;

    this.frmsearchfactura.show(() => {
      this.detcompras = [];
      document.getElementById('frmcompra').style.overflow = 'auto';
      document.body.style.overflow = 'auto';
      console.log("test");

      this.compra.fecemi = this.frmsearchfactura.factura.fecha;
      this.compra.serie = this.frmsearchfactura.factura.serie;
      this.compra.numero = (this.frmsearchfactura.factura.numero).toString();

      this.frmsearchfactura.detfactus.forEach(detalle => {

        let newdetcompra: DetalleCompra = new DetalleCompra();
        newdetcompra.item = +detalle.item;
        newdetcompra.articulo = detalle.idproduct;
        //newdetcompra.articulo.unidad.unidad=detalle.unidad;
        newdetcompra.cantidad = +detalle.cantidad;
        newdetcompra.precio = +detalle.valorunit;
        newdetcompra.subtotal1 = +detalle.impneto;
        newdetcompra.igv_unit = +detalle.igvi;
        newdetcompra.precioreal = +detalle.preuni;
        newdetcompra.subtotal2 = +detalle.impnetoct;
        console.log(newdetcompra);
        this.detcompras.push(newdetcompra)


        this.detcompras.push()
      });

      this.actualizarTotalesCompra()
    })
  }
  // IsEdit

  getDetCompras() {
    this.data.GetFromValue(this.data.api.detcompra, 'idcompra', this.compra.idcompra).subscribe(r => {
      console.log('Obteniendo detalles de compra', r)

      console.log(this.detcompras);
      r.forEach(det => {
        det.articulo = det.idproduct
      });
      this.detcompras = r
    })
  }

  guardar() {
    if (this.isedit) {
      this.ActualizarCompra()
    } else {
      this.GuardarCompra()
    }
  }

  validateFields(): boolean {
    return this.proveedor.ruc && this.compra.fectra && this.compra.serie && this.compra.numero !== null;
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.validateFields()) {
      console.log('Form Submitted!', this.compra);
    }
  }

  // Cargar lista de proveedores
  getProveedores(): void {
    this.data.GetSimple(this.data.api.proveedor).subscribe(r => {
      this.proveedores = r || [];
    });
  }

  // Al seleccionar proveedor del select, autocompletar campos
  onSelectProveedor(event: any): void {
    const idSeleccionado = event.target.value; // ← no convertir a número
    const encontrado = this.proveedores.find(p => String(p.idprovee) === String(idSeleccionado)); // ← comparar ambos como string
    if (encontrado) {
      this.proveedor = { ...encontrado };
      this.compra.idprovee = this.proveedor.idprovee;
    } else {
      this.proveedor = new Proveedor();
      this.compra.idprovee = null;
    }
  }

  // Abrir modal de nuevo proveedor sin salir del módulo
  ShowNuevoProveedor(): void {
    // ← Quitar el foco del modal Bootstrap antes de abrir el dialog
    const modalEl = document.getElementById('frmcompra');
    if (modalEl) {
        modalEl.removeAttribute('tabindex');
    }

    const dialogRef = this.dialog.open(AddProveedorComponent, {
        width: '1000px',
        autoFocus: true,        // ← forzar foco en el dialog
        restoreFocus: false     // ← no devolver foco al modal Bootstrap
    });

    dialogRef.afterClosed().subscribe(() => {
        // Restaurar tabindex del modal Bootstrap
        if (modalEl) {
            modalEl.setAttribute('tabindex', '-1');
        }
        this.getProveedores();
    });
}

}
